<template>
  <section id="head">
    <div class="container col-xl-12 col-xxl-12 px-4 py-5 bgTop posRel">
      <div class="row align-items-center g-lg-5 py-5">

        <div class=" bgWight formStyle posRel uploadDocumenti">
          <div class="headForm">
            <div class="row g-3 ">
              <div class="text-center">
                <img class="logo" src="https://www.rimborsoalvolo.it/cresources/outform/images/rimborsoalvolo-logo.svg">
              </div>
            </div>
          </div>
          <div class="container ">
            <div class="row g-2 text-center">
              <div class="titleThanks text-uppercase">GRAZIE!</div>
              <p class="my-2 backRun"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/letterina.png" alt=""></p>
              <p class="px-5 mb-5">Il tuo ticket ha identificativo <b>#{{s_ticketid}}</b> Controlla tra un paio di minuti la tua casella di posta.
                Ti abbiamo inviato un messaggio importante. </p>
              <button class="styleBtn mb-3  addPass"  @click="nuovaRichiesta">Inserisci nuova richiesta</button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
    <trust-pilot></trust-pilot>
    <conteggio-reclami></conteggio-reclami>
    <recensioni-f-b></recensioni-f-b>
    <sezione-a-p-r-a></sezione-a-p-r-a>
    <page-footer></page-footer>
</template>

<script>
import {useStore} from "vuex";
import {computed} from "vue";
import ConteggioReclami from "@/components/ConteggioReclami";
import TrustPilot from "@/components/TrustPilot";
import RecensioniFB from "@/components/RecensioniFB";
import SezioneAPRA from "@/components/SezioneAPRA";
import PageFooter from "@/components/PageFooter";

export default {
  name: "UltimoStep",
  setup(){
    const store = useStore();
    const s_completati = computed(()=>store.state.compilazione.stepcompletati);
    const s_ticketid = computed(()=>store.state.compilazione.ticketid);
    const s_conclusione_inviato = computed( ()=>store.state.gtmstate.conclusione);
    return {
      s_completati,
      s_ticketid,
      s_conclusione_inviato,
      pulisciStato: ()=>{
        store.dispatch('volo/commitPulisciStato');
        store.dispatch('compilazione/commitPulisciStato');
        store.dispatch('passeggeri/commitPulisciStato');
        store.dispatch('gtmstate/commitPulisciStato');
      },
      setStepConclusioneInviato: function(){
        store.dispatch('gtmstate/commitSetStatoInvioConclusione',true);
      }
    }
  },
  methods:{
    nuovaRichiesta(){
      this.pulisciStato();
      this.$router.push({name:'step1'});
    }
  },
  components : {
    PageFooter,
    SezioneAPRA,
    RecensioniFB,
    TrustPilot,
    ConteggioReclami,
  },
  mounted(){
    if(this.s_ticketref === null){
      this.$router.push({name:'step1'});
    }else{
      window.scrollTo(0,0);
      if(!this.s_conclusione_inviato) {
        this.setStepConclusioneInviato();
        this.$gtm.trackEvent({
              event: 'step_visitato',
              value: 'conclusione',
            }
        );
      }
    }


  },
}
</script>

<style scoped>

</style>